import SectionHeading from "./SectionHeading";

const nodes = [
  { role: "主线玩家", desc: "公开动作最多的主体，通常是叙事的主导方", tone: "bg-primary-400" },
  { role: "旁系关联", desc: "站在桌边、通过资源或渠道间接参与", tone: "bg-accent-400" },
  { role: "信号放大器", desc: "负责让同一信息扩散到更大范围", tone: "bg-secondary-300" },
  { role: "待补全节点", desc: "存在信息缺口，关系线尚未闭合", tone: "border-2 border-dashed border-background-300" },
];

export default function RelationMap() {
  return (
    <section id="map" className="scroll-mt-16 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="07"
          eyebrow="Network"
          title="关系图谱"
          desc="单点信息常常让人误判方向。把关键主体放进同一张图，看谁在主导、谁在旁系、谁在放大，画面才完整。"
        />

        <div className="grid overflow-hidden rounded-xl bg-background-950 lg:grid-cols-2">
          <div className="flex flex-col justify-center p-6 md:p-9">
            <p className="inline-flex w-fit items-center gap-2 rounded-full border border-accent-500/50 px-3 py-1 text-xs text-accent-300">
              <i className="ri-node-tree" />
              图谱专题 · 示意图
            </p>
            <h3 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              同一张牌桌上，
              <br />
              谁在主导，谁在放风
            </h3>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              下面是一张高度抽象的节点示意。真实拆解中，我们会为每条连线标注入档依据与状态，
              让图谱既是结论，也是可以随时复查的工作底稿。
            </p>

            <ul className="mt-6 space-y-3">
              {nodes.map((n) => (
                <li key={n.role} className="flex items-start gap-3">
                  <span className={`mt-1 h-3 w-3 shrink-0 rounded-sm ${n.tone}`} />
                  <div>
                    <p className="text-sm font-semibold text-background-100">{n.role}</p>
                    <p className="text-xs text-background-300">{n.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative min-h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20investigative%20relationship%20network%20visualization%20with%20glowing%20connected%20nodes%20and%20thin%20lines%20over%20a%20very%20dark%20warm%20textured%20background%2C%20deep%20vermillion%20and%20amber%20node%20highlights%2C%20editorial%20data%20journalism%20aesthetic%2C%20cinematic%20subtle%20glow%2C%20high%20contrast%2C%20minimal%2C%20no%20readable%20text%2C%20no%20people&width=1200&height=900&seq=kanliao-map&orientation=portrait"
              alt="看料网 关系图谱可视化示意图"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-background-950/40" />
            <div className="absolute bottom-4 left-4 rounded-md bg-background-950/80 px-3 py-2 backdrop-blur">
              <p className="font-mono text-xs text-accent-300">SIGNAL · 主信号已确认</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}